var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRuppeIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M13.6165 1.6665H6.3915C3.5665 1.6665 1.6665 3.64984 1.6665 6.59984V13.4082C1.6665 16.3498 3.5665 18.3332 6.3915 18.3332H13.6165C16.4415 18.3332 18.3332 16.3498 18.3332 13.4082V6.59984C18.3332 3.64984 16.4415 1.6665 13.6165 1.6665Z",
    fill: "#714FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9681 7.6665H11.7299C11.6525 7.11279 11.4158 6.62939 11.0288 6.26465L12.7633 6.27344L13 5.5H7.23672L7 6.25146H7.93778L8.90744 6.25586C10 6.30859 10.6692 6.82715 10.8331 7.6665H7.23672L7 8.43994H10.8467C10.7011 9.38916 9.89985 9.87695 8.62974 9.87695H7.06373L7.07284 10.4438L10.651 14.5H11.7117V14.4341L8.34294 10.6152H8.67071C10.6237 10.6152 11.5979 9.69238 11.7436 8.43994H12.7269L12.9681 7.6665Z",
    fill: "#714FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuppeIcon);
export default __webpack_public_path__ + "static/media/ruppe_icon.145ca97b8d35c0f546e5e142e2f5d82b.svg";
export { ForwardRef as ReactComponent };